module.exports = __webpack_public_path__ + "static/media/image_banner_yx.c5f0d6f7.jpg";